export default __webpack_public_path__ + "static/media/background-check.fda3a752.jpg";